var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "title": "Attachment Item",
      "visible": _vm.isOpen,
      "ok-only": "",
      "ok-title": "Close"
    },
    on: {
      "hide": function hide($event) {
        return _vm.$emit('close', false);
      }
    }
  }, _vm._l(_vm.attachments, function (item, index) {
    var _item$url, _item$type, _item$url2;
    return _c('div', {
      key: index,
      staticClass: "p-2 -100 d-flex justify-content-between border-b"
    }, [_c('p', {
      staticClass: "m-0"
    }, [_vm._v("Attachment " + _vm._s(index + 1))]), item !== null && item !== void 0 && item.id ? _c('b-button', {
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.handleDownloadFile(item);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Download")]) : _c('a', {
      attrs: {
        "href": (item !== null && item !== void 0 && item.id ? _vm.apiUrl : '') + ((_item$url = item === null || item === void 0 ? void 0 : item.url) !== null && _item$url !== void 0 ? _item$url : item === null || item === void 0 ? void 0 : item.path),
        "target": "_blank"
      }
    }, [_c('b-button', {
      attrs: {
        "size": "sm"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Download")])], 1), item !== null && item !== void 0 && (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.includes('image') ? _c('img', {
      staticClass: "img-fluid",
      staticStyle: {
        "max-width": "100px",
        "max-height": "100px"
      },
      attrs: {
        "src": _vm.apiUrl + ((_item$url2 = item === null || item === void 0 ? void 0 : item.url) !== null && _item$url2 !== void 0 ? _item$url2 : item === null || item === void 0 ? void 0 : item.path),
        "alt": "attachment"
      }
    }) : _vm._e()], 1);
  }), 0)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }